module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAJAAAACQAgMAAACaKAorAAAACVBMVEUKlgDl5eX///+4AIuuAAAAWklEQVRYw+3TwQnAIAxA0dQduoRTOITu0yW6g2TKCiJeAr0YcvnvFvkHQSMCAACc3G2peyqxUdal7+kh8ouGNI8v4z2io2TfmMg1eu3lDI307/sSnYgAAMAZH1OdSDCNvfoGAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/techcrunch-cn.png
// module id = pgAv
// module chunks = 0